import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import JisDialogForm from "../../components/formdialog";
import MultiSelectDropdown from "../../components/controls/multiselectdropdown";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import JisTabButton from "../../components/controls/jisTabButton";
import PdfViewer from "../../components/controls/pdfviewer";
import * as Services from "../../services";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import { X } from "lucide-react";

function HeadOfAppealWritCases() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isLiti, setIsLitiation] = useState(null);
  const [isRework, setIsRework] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [processMode, setProcessMode] = useState("");
  const [selectedClaimTypes, setSelectedClaimTypes] = useState([]);
  const [tab, setTab] = useState("pending");
  const [documents, setDocuments] = useState([]);
  const [isDocPreview, setIsDocPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [selectedGaz, setSelectedGaz] = useState(null);
  const [gazettes, setGazettes] = useState([]);
  const [missingDocs, setMissingDocs] = useState([]);
  const [clearStatus, setClearStatus] = useState(null);

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search, tab]);

  useEffect(() => {
    if (isRework == true) {
      onLoadDocuments();
      onLoadGazette();
    }
  }, [isRework]);

  const claimTypes = [
    { id: 1, title: "Mortgage" },
    { id: 2, title: "Liquidated Damage" },
    { id: 3, title: "Foreigner Involved" },
    { id: 4, title: "Non Capital Offense" },
    { id: 5, title: "Non Capital Offense" },
    { id: 6, title: "Other" },
    { id: 7, title: "None" },
  ];
  const onCheck = (value, id) => {
    let sel = selected;
    if (value) {
      sel.add(id);
    } else {
      sel.delete(id);
    }
    setSelected(new Set(sel));
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/head-of-appeal-post-judgement/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onVerifyStay = async () => {
    var _active = active;
    setLoading(true);
    const verified = await Services.onVerifyAppeal(active.case?.caseId);
    setActive({ ...active, verified });
    setLoading(false);
  };

  const onAddMissingDoc = (gazid) => {
    // check if it already exists
    console.log(active);
    const gazExist = missingDocs.find((d) => d.id == gazid);
    console.log(` selected id ${gazid}`);
    console.log(gazExist);

    if (!gazExist) {
      const newGaz = gazettes.find((d) => d.id == gazid);
      console.log(` selected id ${gazid} inside`);
      console.log(newGaz);
      if (!newGaz) return;

      setMissingDocs((prev) => [...prev, { ...newGaz }]);
    }
  };
  const onRemoveMissing = (gazid) => {
    setMissingDocs((prev) => prev.filter((d) => d.id !== gazid));
  };

  const onLoadDocuments = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${active?.caseId}/documents`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setDocuments(data.documents);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };
  const onAdrLitigation = (cc, ind) => {
    //can load the option for filing type and display

    setActive(cc);
    setIndex(ind);
    setOpenOption(true);
    setOption({
      caseId: cc.caseId,
      caseCategoryId: cc.caseCategoryId,
      divisionId: cc.divisionId,
    });
    setSuitnumber("");
    setProcessMode(cc.processType);
  };

  const onSave = async (e) => {
    e.preventDefault();

    if (active.verified == null) {
      setErr("Please Check that its not Appeal online");
      return;
    }
    if (active.verified == false) {
      setErr("Its confirmed it has Motion on it. You cant continue");
      return;
    }
    if (option.manualVerify != true) {
      setErr(
        "Please check to confirm you have also confirm manually that its not on Appeal",
      );
      return;
    }

    var approve = { ...option, writId: active.id, source: "hoa" };

    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/post-judgement-clear/${active.id}`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        const ft = cases.filter((_, i) => i !== index);
        setCases(ft);
        if (isLiti == false) {
          setAlert({
            open: true,
            title: "Option",
            subtitle: "rejected successfully",
          });
        } else {
          setAlert({
            open: true,
            title: "Option",
            subtitle: "accepted successfully",
          });
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };
  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };
  const onPreviewDoc = (docs) => {
    setIsDocPreview(true);
    console.log(docs);
    console.log("here is called");
    var finalpath = "";
    if (docs.documentLocation != null) {
      finalpath = Constants.RelativeFiletoRelative(
        Constants.getDocumentPath(docs)
      );
    } else {
      finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
    }
    setPreviewUrl(finalpath);
  };
  const rework_handleChange = (id, field, value) => {
    setDocuments((prev) =>
      prev.map((d) => (d.id === id ? { ...d, [field]: value } : d)),
    );
  };

  const onLoadGazette = async () => {
    //for account registration
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/setup/gazette-for-rework/${active.caseFilingId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();

      console.log(data);
      if (data.code === 0) {
        setGazettes(data.gazettes);
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader onSearch={onSearch} frequentData={frequentData} />

      <div className="tab_body" style={{ marginBottom: 24 }}>
        <div className="tab_section">
          <JisTabButton
            isActive={tab == "pending"}
            title="Pending"
            isRoleBased={false}
            onClick={() => onChangeTab("pending")}
          />

          <JisTabButton
            isActive={tab == "rework"}
            title="Rework Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("rework")}
          />

          <JisTabButton
            isActive={tab == "reject"}
            title="Rejected Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("reject")}
          />

          <JisTabButton
            isActive={tab == "processed"}
            title="Processed Cases"
            isRoleBased={false}
            onClick={() => onChangeTab("processed")}
          />
        </div>
        <div className="tab_view"></div>
      </div>

      {cases?.length == 0 && <JisEmptyList />}
      {cases?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>ACR Cases </span>
          </div>
          <div className="table-wrapper">
            <table class="case-table">
              <thead>
                <tr>
                  <th className="col-title">Suit Number</th>
                  <th className="col-title">Case Title</th>
                  <th>Party</th>
                  <th className="col-medium">Filing Type</th>
                  <th className="col-medium">Classification</th>
                  <th className="col-medium">Date Initiated</th>
                  <th className="col-medium">Status Level</th>

                  {tab != "processed" && <th>SLA</th>}
                  <th className="col-title">Details</th>

                  {tab != "processed" && <th className="col-action">Action</th>}
                </tr>
              </thead>
              <tbody>
                {cases?.map((opt, index) => {
                  const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: `${Constants.getItemById(frequentData?.casecategories, opt.case?.caseCategoryId)?.colour}`,
                        }}
                      >
                        {opt.case?.caseNumber}
                      </td>
                      <td>{opt.case?.caseTitle}</td>
                      <td>
                        {opt.party.firstName} {opt.party.lastName}
                      </td>
                      <td>
                        {
                          Constants.getItemById(
                            frequentData?.casetype,
                            opt.case?.caseTypeId,
                          )?.caseType1
                        }
                      </td>
                      <td>
                        {" "}
                        {
                          Constants.getItemById(
                            frequentData?.casecategories,
                            opt.case?.caseCategoryId,
                          )?.categoryTitle
                        }
                      </td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        )}
                      </td>
                      <td>
                        {
                          Constants.getItemById(
                            frequentData?.casestatuses,
                            opt.case?.caseStatusId,
                          )?.description
                        }
                      </td>
                      {tab != "processed" && (
                        <td>
                          <DeadlineBadge dateString={opt.slaExpire} />{" "}
                        </td>
                      )}

                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onContinue(opt, index)}
                        >
                          View
                        </JisButton>
                      </td>
                      {tab != "processed" && (
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onAdrLitigation(opt, index)}
                          >
                            Clear
                          </JisButton>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {cases?.length > 0 && (
            <Pagenated
              size={pageSize}
              total={count}
              maxPage={20}
              onPick={onPagePick}
              onChangePageSize={(k) => setPageSize(k)}
            />
          )}
        </div>
      )}
      <BackLoader open={loading} />

      {openCase && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {openOption && (
        // <JisDialogForm
        //   title="Clear Options"
        //   onClose={() => setOpenOption(false)}
        // >
        <div className="hos_clear_option_modal">
          <div className="hos_modal">
            <div className="modal_header">
              <p>Clear Options</p>
              <button onClick={() => setOpenOption(false)}>
                <X />
              </button>
            </div>
            <form className="content_wrapper" onSubmit={onSave}>
              <div>
                {/* <div> forwards to Head of Process </div> */}
                {active.verified == null && (
                  <JisButton variant="outline" onClick={onVerifyStay}>
                    Click to verify Online Appeal not filed{" "}
                  </JisButton>
                )}

                {active.verified == false && (
                  <p className="error" style={{ display: "flex", gap: 5 }}>
                    <div style={{ flex: 1 }}> Appeal on the case</div>
                  </p>
                )}
                {active.verified == true && (
                  <p className="success-box">Confirmed. Not on Appeal</p>
                )}
                <div style={{ marginTop: 12 }}>
                  <JisCheckbox
                    value={option.manualVerify}
                    label="Please confirm you have manually checked, 'Appeal not filed' manually "
                    onChange={(e) => setOption({ ...option, manualVerify: e })}
                  />
                </div>
                <div className="input-group">
                  <label>
                    Comment <span className="required">*</span>{" "}
                  </label>
                  <div className="input-wrapper" style={{ height: 120 }}>
                    <textarea
                      placeholder=" Comment"
                      name="comment"
                      required={true}
                      value={option.comment}
                      onChange={onOptionChange}
                      style={{
                        resize: "none",
                        height: "100%",
                      }}
                    />
                  </div>
                </div>
                {err != "" && <div className="error">{err}</div>}

                <div className="groupbtn">
                  <JisButton type="submit">Save </JisButton>
                  <JisButton
                    type="button"
                    variant="outline"
                    onClick={() => setOpenOption(false)}
                  >
                    Cancel{" "}
                  </JisButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        // </JisDialogForm>
      )}

      {isDocPreview && previewUrl != "" && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setIsDocPreview(false)}
        >
          <div>
            <div style={{ height: "90vh" }}>
              {" "}
              <PdfViewer pdfUrl={previewUrl} />
            </div>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default HeadOfAppealWritCases;
